





























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { merge } from 'lodash';

import { TEntity, TState } from '@/plugins/podolib/services/entities/Entity';
import { TSoles } from '@/plugins/podolib/services/entities/EntitySoles';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';

import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';
import EquipmentsSolesAdd from '@/components/equipments/EquipmentsSolesAdd.vue';
import CompositeCardV2 from '@/components/composite/CompositeCardV2.vue';
import EquipmentsSolesBattery from '@/components/equipments/EquipmentsSolesBattery.vue';
import EquipmentsSolesDelete from '@/components/equipments/EquipmentsSolesDelete.vue';
import ElementUpdateSoles from '@/components/elements/dfu/ElementUpdateSoles.vue';
import { Severity } from '@sentry/types';

export type TBatterieInfos = {
  mac: string;
  pending: boolean;
  completed: boolean;
};

enum CheckStatusActionLockedReasons {
  // No pairs of soles in memory
  NoSolePair = 'noSolePair',
  // No station in memory
  NoStation = 'NoStation',
  // No station online
  NoStationOnline = 'noStationOnline',
  // An acquisition is in progress
  AcquisitionInProgress = 'acquisitionInProgress',
}

type TSyncableTable = {
  headers: object[];
  soles: {
    list: TEntity<TSoles>[];
    total: number;
  };
  options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
  };
  pending: boolean;
  disabled: boolean;
  error: Error | null;
};

type CheckStatus = {
  batteries: {
    pending: boolean;
    targets: TBatterieInfos[];
    timeout: any;
  };
  timeout: any;
  pending: boolean;
  error: Error | null;
};

interface IEquipmentsSoles extends Vue {
  table: TSyncableTable;
  check: CheckStatus;
  fetchSoles(): void;
  checkStatus(): void;
  patchSole(solesPair: TEntity<TSoles>): void;
  soleUpdated(solesPairId: TEntity<TSoles>['_id']): void;
}

@Component<IEquipmentsSoles>({
  components: {
    ElementUpdateSoles,
    EquipmentsSolesDelete,
    CompositeCardV2,
    EquipmentsSolesAdd,
    EquipmentsSolesBattery,
    ElementBgIcon,
  },
  async created() {
    this.table.headers = [
      {
        text: this.$t('commons.standards.foot-size'),
        value: 'left.footSize',
        sortable: false,
        width: 100,
      },
      {
        text: this.$t('commons.standards.state'),
        sortable: false,
        value: '__state',
        width: 90,
        align: 'center',
      },
      {
        text: `${this.$tc('commons.standards.battery', 2)} (${(this.$t('commons.standards.left') as string).charAt(
          0,
        )}|${(this.$t('commons.standards.right') as string).charAt(0)})`,
        sortable: false,
        value: '__batteries',
        width: 130,
        align: 'center',
      },
      { text: this.$t('commons.standards.code'), value: 'abbr', width: 100 },
      { text: this.$tc('commons.standards.version', 1), value: '__version', width: '100%' },
      { sortable: false, value: '__actions', width: '68' },
    ];

    this.$pdc.bus!.on('entities:soles:created', this.fetchSoles);
    this.$pdc.bus!.on('entities:soles:patched', this.patchSole);
    this.$pdc.bus!.on('entities:soles:updated', this.soleUpdated);
    this.$pdc.bus!.on('entities:soles:removed', this.fetchSoles);
    this.$pdc.bus!.on('entities:soles:assigned', this.fetchSoles);
    this.$pdc.bus!.on('entities:soles:unassigned', this.fetchSoles);
    this.$pdc.bus!.on('entities:stations:patched', this.checkStatus);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('entities:soles:created', this.fetchSoles);
    this.$pdc.bus!.off('entities:soles:patched', this.patchSole);
    this.$pdc.bus!.off('entities:soles:updated', this.soleUpdated);
    this.$pdc.bus!.off('entities:soles:removed', this.fetchSoles);
    this.$pdc.bus!.off('entities:soles:assigned', this.fetchSoles);
    this.$pdc.bus!.off('entities:soles:unassigned', this.fetchSoles);
    this.$pdc.bus!.off('entities:stations:patched', this.checkStatus);
  },
})
export default class EquipmentsSoles extends Vue {
  table: TSyncableTable = {
    // Values prefixed with "__" are virtuals : they are not in entity documents, they are only used
    //    to customize the table with row that have access to the entire document.
    headers: [],
    soles: {
      list: [],
      total: 0,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['left.footSize'],
      sortDesc: [false],
    },
    pending: false,
    disabled: false,
    error: null,
  };
  loading: boolean = false;

  check: CheckStatus = {
    batteries: {
      pending: false,
      targets: [],
      timeout: null,
    },
    timeout: null,
    pending: false,
    error: null,
  };

  get soles(): TState<TEntity<TSoles>> {
    return this.$pdc.entities!.soles.storedEntity;
  }

  get stations(): TState<TEntity<TStation>> {
    return this.$pdc.entities!.stations.storedEntity;
  }

  /*isSoleAcquisitionInProgress(id: string) {
    if (this.acquisitionInProgress.status) {
      return this.acquisitionInProgress.command.command.solesId === id;
    } else return false;
  }*/

  // Make enum compatible for DOM
  get CheckStatusActionLockedReasons() {
    return CheckStatusActionLockedReasons;
  }

  // Get if whe need to lock "check status" action
  get lockCheckStatusAction(): CheckStatusActionLockedReasons | null {
    switch (true) {
      case this.$pdc.analysis!.manifestHasData:
        return CheckStatusActionLockedReasons.AcquisitionInProgress;
      case !this.table.soles.total:
        return CheckStatusActionLockedReasons.NoSolePair;
      case !this.stations.total:
        return CheckStatusActionLockedReasons.NoStation;
      case !this.stations.list.filter((x) => x.online).length:
        return CheckStatusActionLockedReasons.NoStationOnline;
      default:
        return null;
    }
  }

  @Watch('table.options')
  private async onOptionsChange() {
    /*await this.syncEntity(this.$pdc.entities!.soles, this.table, {
      skipIfTheQueryIsTheSameAsThePreviousOne: true,
      mergeWithLastUsedQuery: true
    });*/
    await this.fetchSoles();
  }

  @Watch('table.soles.total')
  @Watch('table.pending')
  @Watch('check.pending')
  disableTable() {
    this.table.disabled = !this.table.soles.total || this.table.pending /* || this.check.pending*/;
  }

  addPairSoles() {
    this.$pdc.bus!.emit('equipments:soles:add');
  }

  clearCheckStatus() {
    if (this.check.timeout) clearTimeout(this.check.timeout);
    this.$pdc.bus!.off('entities:soles:check-status-shortened', this.completeCheckStatus);
  }

  completeCheckStatus() {
    this.clearCheckStatus();
    // Reset 'pending' flag
    this.check.pending = false;
  }

  async checkStatus() {
    // Check if action is locked
    if (this.lockCheckStatusAction) return;
    // Avoid duplication of the process
    /*if (this.check.pending) return;*/
    // Avoid concurrent processes
    if (this.table.pending) return;

    // Clear process states
    this.clearCheckStatus();

    // Reset states
    this.clearStatus();

    try {
      // Reset 'error' flag
      this.check.error = null;
      // Set 'pending' flag
      this.check.pending = true;

      await this.$pdc.entities!.soles.getBatteries();

      this.check.timeout = setTimeout(this.completeCheckStatus, 5000);

      this.$pdc.bus!.once('entities:soles:check-status-shortened', this.completeCheckStatus);
    } catch (e) {
      // Set 'error' flag
      this.check.error = e;
      // Reset 'pending' flag
      this.check.pending = false;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    }

    /*console.log('Check batteries ...');
    this.loading = true;
    // CLear current timeout if exist
    if (this.table.batteries.timeout) clearTimeout(this.table.batteries.timeout);
    try {
      await this.$pdc.entities!.soles.getBatteries();
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    } catch (e) {
      this.table.error = e;
      this.loading = false;
    }*/
  }

  clearStatus() {
    // Reset states
    this.table.soles.list = this.table.soles.list.map((x) => {
      const { checked, ...sole } = x;
      return sole;
    }) as TEntity<TSoles>[];
  }

  /**
   * @deprecated
   * */
  async checkBatteries() {
    /*console.log('Check batteries ...');
    this.loading = true;
    // CLear current timeout if exist
    if (this.table.batteries.timeout) clearTimeout(this.table.batteries.timeout);
    try {
      await this.$pdc.entities!.soles.getBatteries();
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    } catch (e) {
      this.table.error = e;
      this.loading = false;
    }*/
  }

  /*openDeleteDialog(solesId: string) {
    (this.$refs.delete as any).open(solesId);
  }*/

  /**
   * @deprecated
   */
  openUpdateDialog() {
    (this.$refs.update as any).open();
  }
  /**
   * @deprecated
   */
  get getUpdatableSoles() {
    return this.$store.getters['pdc/entities/soles/getUpdatableSoles'];
  }
  /**
   * @deprecated
   */
  get getCalibratableSoles() {
    return this.$store.getters['pdc/entities/soles/getCalibratableSoles'];
  }

  get notice() {
    let str = [];
    if (this.getUpdatableSoles.length) {
      str.push(this.$tc('commons.sentences.sole-can-be-updated', this.getUpdatableSoles.length));
    }
    /*if (this.getCalibratableSoles.length) {
      str.push(this.$tc('commons.sentences.sole-can-be-calibrated', this.getCalibratableSoles.length));
    }*/

    return str.join('. ');
  }

  async fetchSoles() {
    // Avoid duplication of the process
    /*if (this.table.pending) return;*/
    /*// Avoid concurrent processes
    if (this.check.pending) return;*/

    // Reset states
    this.clearStatus();

    try {
      // Reset 'error' flag
      this.table.error = null;
      // Set 'pending' flag
      this.table.pending = true;

      // Set query
      const query: any = {
        ...this.$pdc.entities?.soles.defaultQuery,
        $limit: this.table.options.itemsPerPage === -1 ? this.table.soles.total : this.table.options.itemsPerPage,
        $skip: this.table.options.itemsPerPage * this.table.options.page - this.table.options.itemsPerPage,
        $sort: {
          [this.table.options.sortBy[0]]: this.table.options.sortDesc[0] ? -1 : 1,
        },
      };

      // Try to retreive entities...
      const response = await this.$pdc.repository!.fetchRessource({
        ressource: 'soles',
        params: query,
      });

      this.table.soles = {
        list: response.data,
        total: response.total,
      };
    } catch (e) {
      // Set 'error' flag
      this.table.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.table.pending = false;

      await this.checkStatus();
    }
  }

  async patchSole(solesPair: TEntity<TSoles>) {
    const _targetIndex = this.table.soles.list.findIndex((x) => x._id === solesPair._id);
    if (_targetIndex >= 0) {
      this.$set(this.table.soles.list, _targetIndex, merge(this.table.soles.list[_targetIndex], solesPair));
      // Analytics
      /*this.$pdc.analytics?.actions.trackSuccess('Insole Refreshed', {
        abbr: solesPair.abbr,
        batteries: {
          left: solesPair.left.battery,
          right: solesPair.right.battery
        }
      });*/
    }

    // Shorten check status
    if (this.table.soles.list.filter((x) => !x.checked).length <= 0) {
      this.$pdc.bus!.emit('entities:soles:check-status-shortened');
    }
  }

  async soleUpdated(solesPairId: TEntity<TSoles>['_id']) {
    const _targetIndex = this.table.soles.list.findIndex((x) => x._id === solesPairId);
    if (_targetIndex >= 0) {
      this.$set(this.table.soles.list, _targetIndex, merge(this.table.soles.list[_targetIndex], { updatable: false }));
    }
  }
}
